import { useState } from "react";

export const useModel = ({ modelId }: { modelId: string }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return {
    modelId,
    isOpen,
    open,
    close,
  };
};
